import React, { Fragment, useEffect, useState } from "react";
import "./couponCard.scss";
import { IconButton, Snackbar, Stack } from "@mui/material";
import dateFormat from "dateformat";
import copy from "copy-to-clipboard";

// Icon
import ContentCopyRoundedIcon from "@mui/icons-material/ContentCopyRounded";
import CloseIcon from "@mui/icons-material/Close";
import paymentStore from "../../store/paymentStore";

const CouponCard = ({ item }) => {
  const [open, setOpen] = useState(false);
  const PaymentStore = paymentStore();
  const [used, setUsed] = useState(false);

  const handleClick = () => {
    if (!used) {
      copy(item.couponName);
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (PaymentStore.usedCouponByUser) {
      PaymentStore.usedCouponByUser.map((u) => {
        if (u === item._id) {
          setUsed(true);
        }
      });
    }
  }, []);

  const action = (
    <Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Fragment>
  );

  return (
    <div className="coupon-card">
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={open}
        autoHideDuration={5000}
        onClose={handleClose}
        message="Copy Successfully"
        action={action}
      />
      <Stack spacing={1} className="transition">
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div style={{ width: "100%" }}>
            <div className="coupon-description">{item.shortDescription}</div>
            <div className="min-order">
              Min. order amount is ₹{item.minOrderValue}.
            </div>
          </div>
          {used && <div className="used">Used</div>}
        </div>
        <div>
          <div className="coupon-code">
            <p>{item.couponName}</p>
            <IconButton className="icon-btn" onClick={handleClick}>
              <ContentCopyRoundedIcon className="icon" />
            </IconButton>
          </div>
          <div className="expire-date">
            Expiry: {dateFormat(new Date(item.validityDate), "dd mmm yyyy")}
          </div>
        </div>
      </Stack>
    </div>
  );
};

export default CouponCard;
